module.exports = __webpack_public_path__ + "static/media/8.0ac45a79.png";